export default "__VITE_ASSET__D0qMzcVr__"